function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import isDeepEqualReact from 'fast-deep-equal/react';
export var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
export var on = function on(obj) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  return obj.addEventListener.apply(obj, args);
};
export var off = function off(obj) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  return obj.removeEventListener.apply(obj, args);
};
export var isDeepEqual = isDeepEqualReact;